import { render, staticRenderFns } from "./EditorAccordion.vue?vue&type=template&id=421b99dc&"
import script from "./EditorAccordion.vue?vue&type=script&lang=js&"
export * from "./EditorAccordion.vue?vue&type=script&lang=js&"
import style0 from "./EditorAccordion.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports